import { ApiaApi, makeApiaUrl } from '@apia/api';
import { EventEmitter, TId } from '@apia/util';
import { usePanelIdentity } from '../common';
import { useEffect, useState } from 'react';

class PanelPositionEmitter extends EventEmitter<{
  panelUpdate: {
    panelId: TId;
    containerId: TId;
    newPosition: number;
  };
}> {}

export const panelPositionEmitter = new PanelPositionEmitter();

/**
 * Permite conocer la posición del panel, se actualiza automáticamente cuando
 * ésta cambia provocando un renderizado en el padre
 */
export function usePanelPosition() {
  const { panelId } = usePanelIdentity();

  const [position, setPosition] = useState<{
    containerId: TId;
    position: number;
  }>();

  useEffect(() => {
    return panelPositionEmitter.on('panelUpdate', (ev) => {
      if (ev.panelId === panelId)
        setPosition({ containerId: ev.containerId, position: ev.newPosition });
    });
  }, [panelId]);

  return position;
}

export async function updatePanelPosition(
  panelId: TId,
  containerId: TId,
  newPosition: number,
) {
  const result = await ApiaApi.post(
    makeApiaUrl({
      action: 'panelMove',
      pnlId: panelId,
      containerId,
      newPosition,
    }),
  );

  const hasUpdated = result?.data && !result.hasError && !result.hasMessages;

  if (hasUpdated)
    panelPositionEmitter.emit('panelUpdate', {
      panelId,
      containerId,
      newPosition,
    });

  return hasUpdated;
}

export function useUpdatePanelPosition() {
  const { panelId } = usePanelIdentity();
  return async function updatePosition(containerId: TId, newPosition: number) {
    return updatePanelPosition(panelId, containerId, newPosition);
  };
}
